import React, {Component} from 'react';

export default class Details extends Component{
constructor(props)
{
  super(props);
  this.changeRev=this.changeRev.bind(this);
  this.changeRep=this.changeRep.bind(this);
  this.changestatus=this.changestatus.bind(this);
  this.state={error:""}
}



changestatus(link)
{
      this.props.handlestatus(link);
}
changeRev()
{

  if(this.props.data.surveylink=="")
  {
    this.setState({error:"Please enter survey link first"})
  }
  else{
  if(this.props.data.step!="review")
  {
  this.props.handlestep("review");
  this.setState({error:""})
  }
}

}
changeRep()
{
  if(this.props.data.step!="review")
  {
    this.setState({error:"Please finsish the review step and enter report link"});
  }
  else if(this.props.data.reportlink=="")
  {
    this.setState({error:"Please enter report link first"});
  }
  else{
    if(this.props.data.step!="report")
    {
      this.props.handlestep("report");
      this.setState({error:""});
    }
}

}
render()
{
  var st={
        attri:{
        height:"255px",
        backgroundColor:"#ffffff",
        borderRadius: "7px",
      },
      blue:{
        borderRadius:"20px",
            backgroundColor:" #1a84eb",
            borderBottomRightRadius:0,
            borderBottomLeftRadius:0,
            height:"11.1px",

      },
      box:{

        borderRadius: "7px",
        borderTopRightRadius:0,
        borderTopLeftRadius:0,
        backgroundColor:"#ffffff",
        boxShadow: "0 3px 5px 0 rgba(0, 0, 0, 0.3)"
      },
      bord:{
            border:"none",
      },
      fcolor:{
        color:"#000000",
      },
      scolor:{
        color:"#000000",
      },

      bttn:{
        textDecoration:'none',
        padding:0,
        border:"none",
        color:"#1a84eb",
        outline:"none !important",
        backgroundColor:"#ffffff !important",
      },
    };
    var revchecked="",revdisable="",repchecked="",repdisable="";


    if(this.props.data.step=="review")
    {
      revchecked="checked";
      revdisable="disabled";
      st.fcolor.color="#1a84eb";
    }
    else {
      repchecked="";
    }
    if(this.props.data.step=="report")
    {
      revchecked="checked";
      revdisable="disabled";
      st.fcolor.color="#1a84eb";
      repchecked="checked";
      repdisable="disabled";
      st.scolor.color="#1a84eb";
    }
    var arch;

    if(this.props.data.status=="ACTIVE")
    {
      arch=<button type="button" className="btn btn-default" data-toggle="modal" data-target="#myModal" style={st.bttn} ><strong>ARCHIVE</strong></button>
    }
    else {
      arch="";
    }

    if(arch=="")
    {
      revdisable="disabled";
      repdisable="disabled";
    }

  return(
    <div>
      <div className="img-rounded" style={st.blue}></div>
      <div className="panel panel-default" style={st.box}>
        <div className="panel-body">

      <table className="table" style={st.table_attri}>
        <tbody>
          <tr>
            <td colSpan="4" style={st.bord} ><h4><strong>DETAILS</strong></h4></td>
          </tr>

          <tr>
            <td style={st.bord}>
              <strong>Steps</strong>
            </td>
            <td style={st.bord}>
                <ul className="list-unstyled">
                <li>
                  <div className="material-switch">
                    <input id="someSwitchOptionPrimary" checked name="someSwitchOption001" type="checkbox" ref="commu" onChange={this.changeComm}/>
                    <label htmlFor="someSwitchOptionPrimary" className="label-primary"></label>
                  </div>
                </li>
                <br />
                <li style={{color:"#1a84eb"}}>Communicate</li>
                </ul>
            </td>

            <td style={st.bord}>
            <ul className="list-unstyled">
            <li>
              <div className="material-switch">
                <input id="someSwitchOptionPrimary2"  disabled={revdisable} checked={revchecked} name="someSwitchOption001" type="checkbox" ref="rev" onChange={this.changeRev}/>
                <label htmlFor="someSwitchOptionPrimary2" className="label-primary"></label>
              </div>
            </li>
            <br />
            <li style={st.fcolor}>Review</li>
            </ul>
            </td>

            <td style={st.bord}>
              <ul className="list-unstyled">
                <li>
                  <div className="material-switch">
                    <input id="someSwitchOptionPrimary1" disabled={repdisable} checked={repchecked} className="disable" name="someSwitchOption001" type="checkbox" onChange={this.changeRep}/>
                    <label htmlFor="someSwitchOptionPrimary1" className="label-primary"></label>
                  </div>
                </li>
              <br />

              <li style={st.scolor}>Report</li>

              </ul>
            </td>
          </tr>
          <tr>
            <td colSpan="3" style={st.bord}><strong>Status : </strong>{this.props.data.status}</td>
            <td style={st.bord} className="text-Right">{arch}</td>
            <Mod handlestatus={this.changestatus} />
          </tr>
          <tr>
            <td colSpan="4" style={st.bord}><strong>Date of Start : </strong>{this.props.data.start}</td>
          </tr>
        </tbody>
      </table>
      <p className="text-danger">{this.state.error}</p>
    </div>

    </div>

</div>
  );

}
}
class Mod extends Component{
  constructor(props)
  {
    super(props);
    this.checkDone=this.checkDone.bind(this);
  }
  checkDone()
  {
    this.props.handlestatus("archived");
  }
  render()
  {
    return(
      <div className="modal fade" id="myModal" role="dialog">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">&times;</button>
              <h4 className="modal-title">Enter link of the survey form</h4>
            </div>
            <div className="modal-body form-group">
          <div className="row">

              <p className="col-md-5">Are you sure you want to change status to archive?</p>
              <div className="col-md-1"><button type="button" className="btn btn-default " data-dismiss="modal" onClick={this.checkDone}>Yes</button></div>
              <div className="col-md-1"><button type="button" className="btn btn-default" data-dismiss="modal">No</button></div>
            </div>
          </div>

          </div>
        </div>

      </div>


    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/Home/details.js
 **/